// config for the app

export const config = {
    // the name of the app
    k4api_spotify_id: "9135a076-3196-4f97-8468-47f5c582552c",
    k4api_spotify_check_interval: 3000,
}
